<template>
  <SogCard>
    <SogCardTitle>Wählen Sie ein Datei aus</SogCardTitle>
    <SogCardContent v-show="!_camera">
      <SogUploader
        ref="_uploader"
        v-model="_array"
        :multiple="false"
      />
    </SogCardContent>
    <SogCardContent v-show="_array.length>0||_fileName">
      <SogFormField>
        <SogTextBox
          v-model="_name"
          placeholder="Name"
        />
      </SogFormField>
      <SogFormField v-show="_fileName">
        <SogDataLabel :value="_fileName.fileName" />
      </SogFormField>
    </SogCardContent>
    <SogCardContent hidden="hidden">
      <input
        ref="_cameraInput"
        type="file"
        accept="image/*"
        capture="camera"
        @change="onCameraChange"
      >
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogUploader from "@/shared/ui/SogUploader.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {ref, watch} from "vue";
import {TempFileInfo} from "@/shared/model/TempFileInfo";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {UploaderComponent} from "@syncfusion/ej2-vue-inputs";
import apiTest from "@/modules/Test/api";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  modelValue?:{id?:string,fileName?:string,name?:string}
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  modelValue:undefined
  }
)

const _emit = defineEmits<{
  (e: 'change' ): void,
  (e: 'update:modelValue', value?: {id?:string,fileName?:string,name?:string}): void
}>();

const _fileName = ref<{id:string,fileName:string}>({id:"",fileName:""})
const _camera = ref(false)
const _cameraInput = ref<HTMLInputElement | null>(null)


const _array = ref<TempFileInfo[]>([])
const _name = ref("")
const _uploader = ref<InstanceType<typeof UploaderComponent>  | null>(null)


watch(([_array,_name,_fileName]),()=>{
  let value = undefined;
  if(_camera.value&&_fileName.value){
    value = {id:_fileName.value.id,fileName:_fileName.value.fileName,name:_name.value}
  }
  if(_array.value.length>0) {
    value = {id: _array.value[0].id, fileName: _array.value[0].fileName, name: _name.value}
  }
  _emit("update:modelValue",value)
  _emit("change")
})


async function onCameraChange() {
  console.log("§§§")

  const input = _cameraInput.value // HTML-Element für die Anzeige des Kamerabildes
  if (!input?.files)
    return

  if (input.files.length > 0) {
    const file = input.files[0];

    console.log(file.name)

    const id = await apiTest.uploadTempFile(file.name, file)
    if(!id)
      return
    _fileName.value = {id:id,fileName:file.name}
    console.log(_fileName.value)
  }

}

function clear () {
  _uploader.value?.clear()
  _camera.value = false;
}

function takePhoto() {
  console.log("take")
  _camera.value = true
  const input = _cameraInput.value // HTML-Element für die Anzeige des Kamerabildes

  if(input)
    input.click()
}

defineExpose({
  clear,takePhoto
})


</script>

<style scoped>

</style>
